import { render, staticRenderFns } from "./BusinessOpportunity.vue?vue&type=template&id=1e48e54d&scoped=true"
import script from "./BusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunity.vue?vue&type=style&index=0&id=1e48e54d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48e54d",
  null
  
)

export default component.exports